(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[117],{

/***/ 303:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/operators",
      function () {
        return __webpack_require__(66933);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ OperatorsPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _layouts_MarketingLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71876);
/* harmony import */ var _old_marketing_utils_heroRenderer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23939);
/* harmony import */ var _old_marketing_utils_sectionRenderer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68063);




var __N_SSG = true;
function OperatorsPage(param) {
    var operatorsPage = param.operatorsPage;
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (0,_old_marketing_utils_heroRenderer__WEBPACK_IMPORTED_MODULE_2__/* .heroRenderer */ .a)(operatorsPage === null || operatorsPage === void 0 ? void 0 : operatorsPage.hero),
            operatorsPage === null || operatorsPage === void 0 ? void 0 : (ref = operatorsPage.sections) === null || ref === void 0 ? void 0 : ref.map(function(section, index) {
                return (0,_old_marketing_utils_sectionRenderer__WEBPACK_IMPORTED_MODULE_3__/* .sectionRenderer */ .E)(section, index);
            })
        ]
    });
};
OperatorsPage.layout = _layouts_MarketingLayout__WEBPACK_IMPORTED_MODULE_1__/* .MarketingLayout */ .z;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [512,851,276,497,478,664,63,939,774,888,179], function() { return __webpack_exec__(303); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);